var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "130px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "通知标题", prop: "title" } },
            [
              _c("el-input", {
                staticClass: "form-item-width",
                attrs: {
                  type: "text",
                  clearable: "",
                  placeholder: "请输入通知标题",
                  disabled: _vm.isDetail
                },
                model: {
                  value: _vm.childData.title,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "title", $$v)
                  },
                  expression: "childData.title"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "通知内容" } },
            [
              _c("Tinymce", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isDetail,
                    expression: "!isDetail"
                  }
                ],
                ref: "editor",
                attrs: { menubar: !_vm.isDetail, height: 250 },
                model: {
                  value: _vm.childData.content,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "content", $$v)
                  },
                  expression: "childData.content"
                }
              }),
              _c("Tinymce", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isDetail,
                    expression: "isDetail"
                  }
                ],
                ref: "viewer",
                staticStyle: { width: "580px" },
                attrs: {
                  height: 250,
                  menubar: false,
                  toolbar: _vm.toolbar,
                  readonly: _vm.readonly
                },
                model: {
                  value: _vm.childData.contentText,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "contentText", $$v)
                  },
                  expression: "childData.contentText"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "有效期限", prop: "activeDates" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "400px" },
                attrs: {
                  disabled: _vm.isDetail,
                  "value-format": "yyyy-MM-dd",
                  type: "daterange",
                  "range-separator": "至",
                  "start-placeholder": "有效期限开始时间",
                  "end-placeholder": "有效期限结束时间"
                },
                model: {
                  value: _vm.childData.activeDates,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "activeDates", $$v)
                  },
                  expression: "childData.activeDates"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "通知类型", prop: "noticeTypeId" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "200px" },
                  attrs: { disabled: _vm.isDetail },
                  model: {
                    value: _vm.childData.noticeTypeId,
                    callback: function($$v) {
                      _vm.$set(_vm.childData, "noticeTypeId", $$v)
                    },
                    expression: "childData.noticeTypeId"
                  }
                },
                _vm._l(_vm.typeOption, function(item) {
                  return _c("el-option", {
                    key: item.noticeTypeId,
                    attrs: {
                      label: item.noticeTypeName,
                      value: item.noticeTypeId
                    }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          !_vm.isDetail
            ? _c("el-button", { on: { click: _vm.handCancle } }, [
                _vm._v(_vm._s(_vm.$t("button.cancel")))
              ])
            : _vm._e(),
          !_vm.isDetail
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
                [_vm._v(_vm._s(_vm.$t("button.confirm")))]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }